import { render, staticRenderFns } from "./problem-edit-dic.vue?vue&type=template&id=013a50fc"
import script from "./problem-edit-dic.vue?vue&type=script&lang=js"
export * from "./problem-edit-dic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports